<template>
  <div class="products-admin">
    <el-button type="primary" @click="openDialog()">新增产品</el-button>

    <el-table border :data="tableData" v-loading="loading" style="width: 100%; margin-top: 16px">
      <el-table-column prop="Id" label="序号" width="80"></el-table-column>
      <el-table-column prop="Title" label="产品名称" min-width="160"></el-table-column>
      <el-table-column prop="Img" label="封面" width="120">
        <template slot-scope="scope">
          <img v-if="scope.row.Img" class="table-thumb" :src="$img(scope.row.Img)" alt />
          <span v-else class="muted">暂无</span>
        </template>
      </el-table-column>
      <el-table-column prop="Summary" label="摘要" min-width="220">
        <template slot-scope="scope">
          <span>{{ truncate(scope.row.Summary, 60) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <div class="op-btns">
            <el-button
              type="primary"
              icon="el-icon-edit"
              @click="handleEdit(scope.row)"
            ></el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click="handleDelete(scope.row)"
            ></el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      :title="formData.Id ? '编辑产品' : '新增产品'"
      :visible.sync="dialogFormVisible"
      width="860px"
      top="6vh"
    >
      <el-form :model="formData" label-width="96px">
        <el-form-item label="产品名称">
          <el-input v-model="formData.Title" placeholder="请输入产品名称"></el-input>
        </el-form-item>
        <el-form-item label="列表摘要">
          <el-input
            type="textarea"
            :rows="2"
            v-model="formData.Summary"
            placeholder="用于产品列表展示的简短介绍"
          ></el-input>
        </el-form-item>
        <el-form-item label="封面图片">
          <el-upload
            class="avatar-uploader"
            :action="$uploadAction"
            :headers="headers"
            :show-file-list="false"
            :on-success="handleSuccess"
          >
            <img v-if="formData.Img" :src="$img(formData.Img)" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="产品详情">
          <rich-editor v-model="formData.Content" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" :loading="saving" @click="handleCreateOrModify">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import RichEditor from "../../components/RichEditor.vue";

export default {
  components: { RichEditor },
  data() {
    return {
      loading: true,
      saving: false,
      dialogFormVisible: false,
      tableData: [],
      formData: this.emptyForm(),
      headers: {}
    };
  },
  mounted() {
    const token = sessionStorage.getItem("token");
    this.headers = { Authorization: "Bearer " + token };
    this.loadData();
  },
  methods: {
    emptyForm() {
      return {
        Id: 0,
        Title: "",
        Img: "",
        Summary: "",
        Content: "<p>请填写产品详情，可插入或粘贴图片。</p>",
        CreateTime: new Date()
      };
    },
    truncate(text, len) {
      if (!text) return "";
      return text.length > len ? text.slice(0, len) + "..." : text;
    },
    handleSuccess(response) {
      this.formData.Img = this.$uploadResult(response);
    },
    loadData() {
      this.loading = true;
      this.$http
        .get("Product")
        .then(response => {
          this.tableData = response.data || [];
          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
          this.$message.error("加载失败：" + e);
        });
    },
    openDialog() {
      this.formData = this.emptyForm();
      this.dialogFormVisible = true;
    },
    handleEdit(row) {
      this.formData = {
        Id: row.Id,
        Title: row.Title || "",
        Img: row.Img || "",
        Summary: row.Summary || "",
        Content: row.Content || "",
        CreateTime: row.CreateTime || new Date()
      };
      this.dialogFormVisible = true;
    },
    handleCreateOrModify() {
      if (!this.formData.Title) {
        this.$message.warning("请填写产品名称");
        return;
      }
      this.saving = true;
      this.$http
        .put("Product", this.formData)
        .then(() => {
          this.saving = false;
          this.dialogFormVisible = false;
          this.$message.success(this.formData.Id ? "修改成功" : "创建成功");
          this.loadData();
        })
        .catch(e => {
          this.saving = false;
          this.$message.error("保存失败：" + e);
        });
    },
    handleDelete(row) {
      this.$confirm("确认删除该产品吗？", "提示", {
        type: "warning"
      })
        .then(() => {
          this.loading = true;
          return this.$http.delete(`Product/${row.Id}`);
        })
        .then(() => {
          this.$message.success("删除成功");
          this.loadData();
        })
        .catch(e => {
          this.loading = false;
          if (e !== "cancel") this.$message.error("删除失败：" + e);
        });
    }
  }
};
</script>

<style scoped>
.muted {
  color: #9aaaba;
  font-size: 12px;
}

.op-btns {
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap;
  white-space: nowrap;
  gap: 8px;
}

.op-btns >>> .el-button + .el-button {
  margin-left: 0;
}
</style>
